import React from 'react';
import "../styles/AlertBar.css";

export default function AlertBar({ alertHTML }) {
    return (
        <div className="AlertBar" dangerouslySetInnerHTML={{__html: alertHTML}}></div>
    )
}